// import RepositoryFactory from "@/apis";
// const karunaPoint = RepositoryFactory.karunaPoint;
import karunaPoint from "../../apis/karunaPoint";

export default {
  getKarunaPointByUserId({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await karunaPoint.getKarunaPointByUserId(payload);
        commit("GET_KARUNA_POINT", data.data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
